module.exports = __webpack_public_path__ + "img/CLVHelp3.1b7dda1c.png";